export default function ticketSetReducer(state = null, action){
  switch (action.type) {
    case 'SET_PICTURES': {
        return {
          ...state,
          ticket: {
            data: action.payload.data
          }
        }
    }
    default:
      return state
  }
}

